import { render, staticRenderFns } from "./EmailTip.vue?vue&type=template&id=2af1aae9&scoped=true&"
import script from "./EmailTip.vue?vue&type=script&lang=js&"
export * from "./EmailTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1aae9",
  null
  
)

export default component.exports